import {Button, Checkbox, Collapse, Input, List, ListItem} from "@material-tailwind/react";
import React, {useState} from "react";
import {getMessageHistory} from "../../api/MessageAPI";

export default function DeviceMonitor() {

  const [detailSearchOpen, setDetailSearchOpen] = useState(false)
  const [search, setSearch] = useState({
    'deviceId': '',
    'taskId': '9ca072b4-f01b-4495-a669-5ae8ad98778a',
    'jobType': new Set(),
    'roundNum': '',
    'result': new Set()
  })
  const [searchResult, setSearchResult] = useState([])

  const jobTypes = ["TRAINING", "EVALUATION", "TEST"]
  const results = ["Init", "Success", "Fail"]

  const toggleDetailSearchOpen = () => setDetailSearchOpen((cur) => !cur)

  const handleCheckboxChange = (searchField, item, checked) => {
    if (checked) {
      search[searchField].add(item)
    } else {
      search[searchField].delete(item)
    }
    setSearch({...search, [searchField]: search[searchField]})
  }

  const handleSearch = (e) => {
    e.preventDefault()
    getMessageHistory(search)
      .then(res => {
        console.log(res.data.data)
        setSearchResult(res.data.data)
      })
      .catch(err => console.log(err))
  }

  return (
    <>
      <form onSubmit={handleSearch}>
        <div className="flex">
          <div className="w-96">
            <Input
              label="Task ID"
              defaultValue={search['taskId']}
              onChange={e => setSearch({...search, 'taskId': e.target.value})}
            />
          </div>
          <div className="w-96 pl-2">
            <Input
              label="Device ID"
              onChange={e => setSearch({...search, 'deviceId': e.target.value})}
            />
          </div>
          <div className="pl-2">
            <Input
              label="Round"
              onChange={e => setSearch({...search, 'roundNum': e.target.value})}
            />
          </div>
          <Button
            color={"cyan"}
            className="flex items-center gap-2 rounded-full ml-3"
            onClick={handleSearch}
            type={"submit"}
          >
            Search
          </Button>
        </div>

        <div className="my-3 text-center">
          <Button size="sm" variant="outlined" onClick={toggleDetailSearchOpen} fullWidth>⇓</Button>
        </div>
        <Collapse open={detailSearchOpen}>
          <div className="grid grid-cols-1 2xl:grid-cols-3 gap-4">
            <div className="my-2 border-2 rounded-lg">
              <p className="text-center font-bold">
                Job Type (No select is all select)
              </p>
              <List className="flex-row justify-center p-0 mr-2">
                {
                  jobTypes.map(item => {
                    return <label key={item}>
                      <ListItem className="p-0">
                        <Checkbox
                          label={item}
                          value={item}
                          onChange={e => handleCheckboxChange('jobType', e.target.value, e.target.checked)}/>
                      </ListItem>
                    </label>
                  })
                }
              </List>
            </div>

            <div className="my-2 border-2 rounded-lg">
              <p className="text-center font-bold">
                Result (No select is all select)
              </p>
              <List className="flex-row justify-center p-0">
                {
                  results.map(item => {
                    return <label key={item}>
                      <ListItem className="p-0">
                        <Checkbox
                          label={item}
                          value={item}
                          onChange={e => handleCheckboxChange('result', e.target.value, e.target.checked)}/>
                      </ListItem>
                    </label>
                  })
                }
              </List>
            </div>
          </div>
        </Collapse>
      </form>

      <div className="overflow-auto h-[calc(100vh-310px)]">
        <div className="flex m-2 font-bold gap-2">
          <div className="w-1/12">
            Result
          </div>
          <div className="w-2/12">
            Device ID
          </div>
          <div className="w-2/12">
            Task ID
          </div>
          <div className="w-1/12">
            Job Type
          </div>
          <div className="w-1/12">
            Round
          </div>
          <div className="w-2/12">
            Request Time
          </div>
          <div className="w-3/12">
            Task Info
          </div>
        </div>

        <div>
          {
            searchResult.map((item, idx) => {
              return <div key={idx}>
                <hr className="h-0.5 bg-neutral-100 opacity-100 dark:opacity-50"/>
                <div className="flex m-2 gap-2">
                  <div className="w-1/12">
                    {item['result']}
                  </div>
                  <div className="w-2/12">
                    {item['deviceId']}
                  </div>
                  <div className="w-2/12">
                    {item['taskId']}
                  </div>
                  <div className="w-1/12">
                    {item['jobType']}
                  </div>
                  <div className="w-1/12">
                    {item['roundNum']}
                  </div>
                  <div className="w-2/12">
                    {item['createTime']}
                  </div>
                  <div className="w-3/12">
                <pre>
                {JSON.stringify(item['taskInfo'], undefined, 2)}
                </pre>
                  </div>
                </div>
              </div>
            })
          }
        </div>
      </div>
    </>
  )
}
